import { render, staticRenderFns } from "./homepage_not_updated.vue?vue&type=template&id=6768b420&scoped=true&"
import script from "./homepage_not_updated.vue?vue&type=script&lang=js&"
export * from "./homepage_not_updated.vue?vue&type=script&lang=js&"
import style0 from "./homepage_not_updated.vue?vue&type=style&index=0&id=6768b420&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768b420",
  null
  
)

export default component.exports